export default __webpack_public_path__ + "proximanova-mediumit-webfont.woff2";